import {getField, updateField} from 'vuex-map-fields';
import BatchRun from '@/commonFunction/baseTableModule'

let batch_run_history_item = new BatchRun('/ws/table/batch_run_history_item/');

const state = {
    ...batch_run_history_item.state,
    options: {
                page: 1,
                itemsPerPage: 100,
                sortBy: ['title'],
                sortDesc: [false, true],
                multiSort: false,
                mustSort: true,
                descending: false,

            },
    columns: [
        {text: 'Notion', value: 'notion_id', sortable: true, divider: true, width: 30, brief: true,},
        {text: 'Title', value: 'title', sortable: true, divider: true, brief: true,},
        {text: 'Target date', value: 'delivery_date', sortable: true, divider: true, width: 40, brief: true, align: 'end',},
        {text: 'End', value: 'batch_run_end', sortable: true, divider: true, width: 40, brief: true, align: 'end',},

        {text: 'Real days / Plan days (%)', value: 'real_per_plan', sortable: true, divider: true, width: 70, brief: true,},
        {text: 'SMD real days / SMD plan days (%)', value: 'smd_real_per_plan', sortable: true, divider: true, width: 70, brief: true,},
        {text: 'THT real days / THT plan days (%)', value: 'tht_real_per_plan', sortable: true, divider: true, width: 70, brief: true,},

        {text: 'SMD', value: 'smd', sortable: true, divider: true, width: 30, brief: true, align: 'end',},
        {text: 'THT', value: 'tht', sortable: true, divider: true, width: 30, brief: true, align: 'end',},

        {text: 'SMD lead time plan', value: 'smd_plan_work_day', sortable: true, divider: true, width: 30, brief: true, align: 'end',},
        {text: 'SMD real work (day)', value: 'smd_work_day', sortable: true, divider: true, width: 30, brief: true, align: 'end',},
        {text: 'SMD start delay (day)', value: 'smd_start_diff', sortable: true, divider: true, width: 30, brief: true, align: 'end',},

        {text: 'THT lead time plan', value: 'tht_plan_work_day', sortable: true, divider: true, width: 30, brief: true, align: 'end',},
        {text: 'THT real work (day)', value: 'tht_work_day', sortable: true, divider: true, width: 30, brief: true, align: 'end',},
        {text: 'THT start delay (day)', value: 'tht_start_diff', sortable: true, divider: true, width: 30, brief: true, align: 'end',},
    ],
};
const getters = {
    ...batch_run_history_item.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true)
        } else {
            return state.columns
        }
    },
};
const actions = {
    ...batch_run_history_item.actions,
};
const mutations = {
    ...batch_run_history_item.mutations,
};

export default {
    modules: {
        BatchRunHistoryItem: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}
